<doka-modal-wrapper (close)="closeModal()">
  <ng-template #title>
    {{ "MasterData.NewCatalogCategoryModal.Title" | i18nextEager }}
  </ng-template>
  <ng-template #content>
    <form [formGroup]="form">
      <div class="flex gap-lg w-full">
        <doka-text-field
          [frontDecoText]="i18n.selectedLanguage.toUpperCase()"
          class="flex-1"
          formControlName="name"
          [label]="'MasterData.NewCatalogCategoryModal.Name' | i18nextEager"
          [placeholder]="'Common.Placeholder' | i18nextEager"
        />
        <doka-text-field
          class="w-14"
          formControlName="code"
          [label]="'MasterData.NewCatalogCategoryModal.Code' | i18nextEager"
        />
      </div>
    </form>
  </ng-template>
  <ng-template #footer>
    <div class="flex flex-col gap-sm w-full">
      <div class="flex w-full gap-md px-6 pt-4 items-center justify-end">
        <doka-button [disabled]="isLoading()" (click)="closeModal()" color="secondary">{{
          "Common.Cancel" | i18nextEager
        }}</doka-button>
        <doka-button type="submit" [disabled]="form.invalid || isLoading()" (click)="submit()" color="primary">{{
          "Common.Save" | i18nextEager
        }}</doka-button>
      </div>
    </div>
  </ng-template>
</doka-modal-wrapper>
